const MenuItemMixin = {
  computed: {
    matchedRoutes() {
      const matches = this.$route.matched
        ? [ ...this.$route.matched ].reverse().map((m) => m.name)
        : [ this.$route.name ];

      return new Set(matches.filter(Boolean));
    },
  },

  methods: {
    isActive(...routes) {
      return routes.some((route) => this.matchedRoutes.has(route));
    },
  },
}

export default MenuItemMixin;
